// CustomerHub (Appstle) account pages render discount CODE names on orders —
// e.g. "TESTSUPPS (-$16.00)" and shipping code "TestShip". Business wants the
// generic word "Discount" shown, never the code. The app owns this markup (no
// editable Liquid), so rewrite the text after it renders and on each re-render.
const scrub = (root) => {
    // Discount rows carrying "<CODE> (-$16.00)" -> "Discount (-$16.00)" (keep amount).
    // Two spots: order-summary list (.chDiscounts li) and product-line tag (.chProductTotal i).
    root.querySelectorAll('.chDiscounts li, .chProductTotal i').forEach((el) => {
        const amount = el.textContent.match(/(\s*\(-.*)$/);
        const next = `Discount${amount ? amount[1] : ''}`;
        if (el.textContent !== next) el.textContent = next;
    });
    // Shipping / cart discount code name -> "Discount".
    root.querySelectorAll('span.cart-discount').forEach((span) => {
        if (span.textContent !== 'Discount') span.textContent = 'Discount';
    });
};

export default function initCustomerHubDiscountLabels() {
    // Account pages only. The CustomerHub app injects its markup async — often after
    // DOMContentLoaded — so observe the document and re-scrub on every render instead
    // of bailing when the hub isn't mounted yet.
    if (!location.pathname.startsWith('/account')) return;

    scrub(document);
    const observer = new MutationObserver(() => scrub(document));
    observer.observe(document.body, { childList: true, subtree: true });
}
